import { render } from "./modal_tarificationstock.vue?vue&type=template&id=4d3f2dca&scoped=true"
import script from "./modal_tarificationstock.vue?vue&type=script&lang=js"
export * from "./modal_tarificationstock.vue?vue&type=script&lang=js"

import "./modal_tarificationstock.vue?vue&type=style&index=0&id=4d3f2dca&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3f2dca"]])

export default __exports__